import { useEffect } from "react";
import { AiFillCaretRight } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import InfoCharge from "./info-charge";

const ChargesDetail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  return (
    <div className="gm-charges-details-container">
      <div className="gm-cd-top-navigation">
        <div className="gm-cd-top-info">
          <div className="gm-cd-disabled" type="button">
            Parámetros
          </div>
          {state?.charge && (
            <>
              <AiFillCaretRight />
              <button onClick={goBack} className="gm-cd-back">
                Perfiles Profesionales
              </button>
            </>
          )}
          {state?.charge && (
            <>
              <AiFillCaretRight />
              <div className="gm-cd-company-info">{`${
                state?.charge?.name || "Cargo"
              }`}</div>
            </>
          )}
        </div>
      </div>
      <InfoCharge
        charge={state?.charge}
        />
    </div>
  );
};

export default ChargesDetail;
